<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_190_2145" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect width="32" height="32" />
</mask>
<g mask="url(#mask0_190_2145)">
<path d="M14.6667 28V17.3333H4V14.6667H14.6667V4H17.3333V14.6667H28V17.3333H17.3333V28H14.6667Z"/>
</g>
</svg>
